import React, {Component } from 'react';

import Firebase from "firebase/app";
import 'firebase/database'

import {
  EventDetailsDisplay, ReservedSpacesDisplay
} from '../components/CustomDisplay'

import {CustomTimePicker} from '../components/CustomPickers'
import {GenericTable} from '../components/Utils'

import { FaTimesCircle } from 'react-icons/fa'

import {validateField, parseEvents, getReservationsForTime} from '../utils'

import {
  UNAUTHORIZED_STATE,
  AUTHORIZED_STATE,
  UPDATE_SUCCESS_STATE,
  ID_FIELD,
  NUMBER_FIELD
} from '../constants'

import {
  INVALID_EVENT_ID,
  INVALID_CLIENT_ID,
  EVENT_NOT_FOUND,
  WRONG_CLIENT_ID,
  CLIENTS_HEADER,
  LOGIN_TITLE,
  EVENT_ID_TITLE,
  CLIENT_ID_TITLE,
  VALIDATE_BUTTON
} from '../strings'

class ClientsHome extends Component {

   constructor(props){
        super(props)
        this.state = {
          eventId: "",
          clientId: "",
          events: "",
          clientsState: UNAUTHORIZED_STATE,
          reservations: {},
          selectedTime: 0,
          errorMessages: {
            eventIdNotValid: false,
            clientIdNotValid: false,
            eventNotFound: false,
            incorrectClientId: false
          }
        }

        this.reservationsHeaders = [
          {name: 'ID', small: true},
          {name: 'Nombre', small: false},
          {name: 'Teléfono', small: true},
          {name: 'Mail', small: false},
          {name: 'Invitados', small: false, render: 'list'}
        ]

        this.handleLogin = this.handleLogin.bind(this)
        this.handleEventIdChange = this.handleEventIdChange.bind(this)
        this.handleClientIdChange = this.handleClientIdChange.bind(this)
        this.parseErrorMessages = this.parseErrorMessages.bind(this)
        this.handleReservedSpacesChange = this.handleReservedSpacesChange.bind(this)
        this.handleReservedSpacesUpdate = this.handleReservedSpacesUpdate.bind(this)
        this.handleTimeChange = this.handleTimeChange.bind(this)
        this.getReservationsTableData = this.getReservationsTableData.bind(this)

  }

  handleLogin(){
    const {eventId, clientId, events, errorMessages} = this.state
    if (eventId.length === 0){
      errorMessages.eventIdNotValid = true
      this.setState({
        errorMessages: errorMessages
      })
      return
    }
    if (clientId.length === 0){
      errorMessages.clientIdNotValid = true
      this.setState({
        errorMessages: errorMessages
      })
      return
    }
    if (events[eventId] === undefined){
      errorMessages.eventNotFound = true
      this.setState({
        errorMessages: errorMessages
      })
      return
    }
    if (events[eventId].client_id !== clientId){
      errorMessages.incorrectClientId = true
      this.setState({
        errorMessages: errorMessages
      })
      return
    }
    // Login success
    const ref = Firebase.database().ref(`/guests/${eventId}`)
    ref.on('value', snapshot => {
        var reservationsFetch = snapshot.val();
        if (reservationsFetch === null){
          reservationsFetch = {}
        }
        this.setState({
          reservations: reservationsFetch
        })
    })
    this.setState({
      clientsState: AUTHORIZED_STATE,
      selectedTime: events[eventId].availableHours[0].time
    })
  }

  /*
   * Handles changes on event ID for login purposes
   */
  handleEventIdChange(event){
      const {errorMessages} = this.state
      const eventIdValue = event.target.value.trim()
      errorMessages.eventNotFound = false
      errorMessages.incorrectClientId = false
      if (!validateField(ID_FIELD, eventIdValue) && eventIdValue.length > 0){
        errorMessages.eventIdNotValid = true
      } else{
        errorMessages.eventIdNotValid = false
      }
      this.setState({
          eventId: eventIdValue,
          errorMessages: errorMessages
      })
  }

  /*
   * Handles changes on Client ID for login purposes
   */
  handleClientIdChange(event){
      const {errorMessages} = this.state
      const clientIdValue = event.target.value.trim()
      errorMessages.incorrectClientId = false
      if (
        !validateField(NUMBER_FIELD, clientIdValue) &&
        clientIdValue.length > 0
      ){
        errorMessages.clientIdNotValid = true
      } else{
        errorMessages.clientIdNotValid = false
      }
      this.setState({
          clientId: clientIdValue,
          errorMessages: errorMessages
      })
  }

  handleReservedSpacesChange(event){
    const {events, eventId} = this.state
    var newReservedSpaces = event.target.value
    if (!newReservedSpaces){
      newReservedSpaces = 0
    }
    events[eventId].reservedSpaces = newReservedSpaces
    this.setState({
      clientsState: AUTHORIZED_STATE,
      events: events
    })
  }

  /*
   * Handle "Actualizar" Button click
   */
  handleReservedSpacesUpdate(){
    const {events, eventId} = this.state
    const reservedSpaces = events[eventId].reservedSpaces
    const dbURL = `/events/${eventId}/reservedSpaces`
    Firebase.database().ref(dbURL).set(reservedSpaces)
    this.setState({
      clientsState: UPDATE_SUCCESS_STATE
    })
  }

  handleTimeChange(event){
    const newTime = event.target.value
    this.setState({
      clientsState: AUTHORIZED_STATE,
      selectedTime: Number(newTime)
    })
  }

  parseErrorMessages(){
    const {errorMessages} = this.state
    if (errorMessages.eventIdNotValid){
      return INVALID_EVENT_ID
    }
    if (errorMessages.clientIdNotValid){
      return INVALID_CLIENT_ID
    }
    if (errorMessages.eventNotFound){
      return EVENT_NOT_FOUND
    }
    if (errorMessages.incorrectClientId){
      return WRONG_CLIENT_ID
    }
    return ""
  }

  getReservationsTableData(){
    const {reservations, selectedTime} = this.state
    const filteredReservations = getReservationsForTime(reservations, selectedTime)
    const result = []
    for (var reservationId in filteredReservations){
      const guests = filteredReservations[reservationId].guests.map(el => el.name)
      const filteredGuests = guests.filter(el => el.length > 0)
      const reservationRow = [
        reservationId,
        filteredReservations[reservationId].personalData.name,
        filteredReservations[reservationId].personalData.phone,
        filteredReservations[reservationId].personalData.mail,
        filteredGuests.join(',')
      ]
      result.push(reservationRow)
    }
    return result
  }

  componentDidMount(){
    const ref = Firebase.database().ref('/events')

    ref.orderByChild('end').startAt(new Date().getTime()).on('value', snapshot => {
        var eventsRaw = snapshot.val()
        if (eventsRaw === null){
          eventsRaw = {}
        }
        const availableEvents = parseEvents(eventsRaw, false)
        this.setState({
            events: availableEvents
        })
    })
  }

  render (){
    const {
      eventId, clientId, clientsState, events, selectedTime
    } = this.state
    const {
      handleLogin,
      handleClientIdChange,
      handleEventIdChange,
      parseErrorMessages,
      handleReservedSpacesChange,
      handleReservedSpacesUpdate,
      handleTimeChange,
      getReservationsTableData,
      reservationsHeaders
    } = this
    return (
      <div>
        <div class="topnav">
            <label>{CLIENTS_HEADER}</label>
        </div>
        {
          clientsState === UNAUTHORIZED_STATE ?
          <div class="registerForm">
              <div class="line-header-text">{LOGIN_TITLE}</div>
              <table>
                  <tr>
                      <th className="login-text">{EVENT_ID_TITLE}</th>
                      <th>
                      <div className="input-error">
                          <input
                              type="text"
                              className="text-input"
                              value={eventId}
                              onChange={handleEventIdChange}
                          />
                      </div>
                      </th>
                  </tr>
                  <tr>
                      <th className="login-text">{CLIENT_ID_TITLE}</th>
                      <th>
                      <div className="input-error">
                          <input
                              type="text"
                              className="text-input"
                              value={clientId}
                              onChange={handleClientIdChange}
                          />
                      </div>
                      </th>
                  </tr>
              </table>
              <div className="main-block">
                  <input
                      class="button-add-reserve"
                      type="button"
                      value={VALIDATE_BUTTON}
                      onClick={handleLogin}
                      disabled={parseErrorMessages().length > 0}/>
              </div>
              <div class="error-message">
              {
                  parseErrorMessages() ?
                      <div>{parseErrorMessages()} <FaTimesCircle class="icon-fail-circle"/></div>
                       : <div></div>
              }
              </div>
          </div> : <div></div>
        }
        {
          [AUTHORIZED_STATE, UPDATE_SUCCESS_STATE].includes(clientsState) ?
          <div className="events-finder-container">
            <div className="reservations-header-container">
              <div className="line-header-text">{events[eventId].name}</div>
              <div>
                <EventDetailsDisplay
                  events={events}
                  selectedEventId={eventId}
                />
              </div>
            </div>
            <div className="shadow-box"></div>
            <div className="shadow-box">
              <ReservedSpacesDisplay
                reservedSpaces={events[eventId].reservedSpaces}
                onChange={handleReservedSpacesChange}
                onUpdate={handleReservedSpacesUpdate}
                updateSuccess={clientsState === UPDATE_SUCCESS_STATE}
              />
            </div>
            <div>
              <div>
                <CustomTimePicker
                  availableHours={events[eventId].availableHours}
                  selectedTime={selectedTime}
                  onTimeSelected={handleTimeChange}
                  showWarning={false}
                />
              </div>
              <div className="clients-reservations-display-table">
                <GenericTable
                  tableData={getReservationsTableData()}
                  headers={reservationsHeaders}
                  columnOrderIndex={1}
                />
              </div>
            </div>
          </div>: <div></div>
        }
    </div>
    )
  }
}

export default ClientsHome
